import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["checked", "disabled", "label", "name", "onChange", "className", "color"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { useId } from 'react';
import { useTheme } from '../Flowbite/ThemeContext';
export var ToggleSwitch = function ToggleSwitch(_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme().theme.toggleSwitch;
  var id = useId();
  var toggle = function toggle() {
    return onChange(!checked);
  };
  var handleClick = function handleClick(event) {
    event.preventDefault();
    toggle();
  };
  var handleKeyPress = function handleKeyPress(event) {
    event.preventDefault();
  };
  return _jsxs(_Fragment, {
    children: [name && checked && _jsx("input", {
      checked: checked,
      hidden: true,
      name: name,
      readOnly: true,
      type: "checkbox",
      className: "sr-only"
    }), _jsxs("button", _objectSpread(_objectSpread({
      "aria-checked": checked,
      "aria-labelledby": "".concat(id, "-flowbite-toggleswitch-label"),
      disabled: disabled,
      id: "".concat(id, "-flowbite-toggleswitch"),
      onClick: handleClick,
      onKeyPress: handleKeyPress,
      role: "switch",
      tabIndex: 0,
      type: "button",
      className: classNames(theme.base, theme.active[disabled ? 'off' : 'on'], className)
    }, props), {}, {
      children: [_jsx("div", {
        className: classNames(theme.toggle.base, theme.toggle.checked[checked ? 'on' : 'off'], !disabled && theme.toggle.checked.color[color])
      }), _jsx("span", {
        "data-testid": "flowbite-toggleswitch-label",
        id: "".concat(id, "-flowbite-toggleswitch-label"),
        className: theme.label,
        children: label
      })]
    }))]
  });
};